var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"html-container mb-4"},[_c('div',{attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }